import React, { useEffect } from 'react'
import { State } from '../../_EOS/State'
import { useApi } from '../../../hooks/useApi'
import { ApiConfig } from '../../../config/api'
import axios from 'axios'
import { ApiResponse } from '../../../typings/ApiResponse'
import { Typography } from '@mui/material'

interface PreviewSkuImageProps {
  skuId: number
}

const getImage = (skuId: number) => {
  const url = new URL(`${ApiConfig.StockKeepingUnitImageApi}`)

  url.searchParams.set('stockKeepingUnitId', skuId.toString())

  return axios.get(url.toString())
}

export const PreviewSkuImage: React.FC<PreviewSkuImageProps> = ({ skuId }) => {
  const { callApi, state } = useApi<ApiResponse<{ url: string }>>()

  const requestImage = () => {
    callApi(getImage(skuId))
  }

  useEffect(() => {
    requestImage()
  }, [])

  return (
    <State state={state} loadingMessage='Obteniendo imágen...'>
      {state.data?.items?.[0]?.url ? (
        <img src={state.data?.items[0].url} width={'500px'} height={'500px'} />
      ) : (
        <Typography variant="body2" color="textSecondary" align='center'>
          Producto sin imagen
        </Typography>
      )}
    </State>
  )
}
